export const AUTH_EXPIRED_EVENT = 'motion-auth-expired'

export function shouldNotifyAuthExpiry(requestStatus: number, verifiedSessionStatus: number | null) {
  if (requestStatus === 401) return true
  return requestStatus === 403 && (verifiedSessionStatus === 401 || verifiedSessionStatus === 403)
}
